import React from 'react';
import { component_tool } from '@/tool'
let { WizRow, WizCol, WizAlert } = component_tool;

// 自定义UI组件 账号字段下的提示部分
export default (
    <WizRow>
        <WizCol md={24} lg={16}>
            <WizAlert message="账号初始密码为:SaicCyc778899a" type="info" showIcon />
        </WizCol>
    </WizRow>
);
